export default "__VITE_ASSET__DSLKDHDT__"